module.exports = __webpack_public_path__ + "img/13.de636c87.jpg";